import { FormSelect } from "components/form-fields";
import { ShowHide } from "components/layout";
import { useValidation } from "hooks/useValidation";
import React, { useEffect, useState } from "react";

export function ManualEntryTemplateSettings({
    template,
    templateType,
    onValidChange,
    options,
    loading,
    saving,
    onTemplateTypeChange,
    onTemplateUpdate,
    withSelectType = true,
    readOnly = false
}) {

    const [templateTypes, setTemplateTypes] = useState([]);
    const [templateRules, setTemplateRules] = useState([]);
    const [showRules, setShowRules] = useState(false);

    const [isValid, errors, validate] = useValidation(false);

    function onTemplateSelect(item) {

        onTemplateTypeChange(item.id);
        if(item.id.indexOf("STAT") === 0) {
            onTemplateUpdate({ ruleset: null })
        }
        
    }

    function onRulesSelect(item) {
        onTemplateUpdate({ ruleset: item.id })
    }

    useEffect(() => {
        const isStatRules = templateType.indexOf("STAT") === 0;
        setShowRules(!isStatRules);
    }, [templateType]);

    useEffect(() => {

        setTemplateTypes(options?.templateTypes?.map(type => {
            return { id: type.key, name: type.name, };
        }) ?? []);

        setTemplateRules(options?.rulesets?.map(type => {
            return { id: type.key, name: type.name, };
        }) ?? []);

    }, [options]);

    useEffect(function () {
        onValidChange(isValid);
    }, [isValid]);

    useEffect(() => {
        const rules = [];

        if(showRules) {
            rules.push({ fieldName: "ruleset", required: true });
        }

        const externalRules = [{ fieldName: "templateType", valid: (templateType?.trim()?.length ?? 0) > 0, errorMessage: "This field is required." }];
        validate(rules, template, externalRules);
    }, [template?.ruleset, templateType, showRules]);

    return (
        <>
            <FormSelect
                id="settings-template-type"
                headingText="Template Type"
                loading={loading}
                disabled={saving || !withSelectType || readOnly}
                placeholder="Please select"
                items={templateTypes}
                onItemSelect={onTemplateSelect}
                selectedValue={templateType}
                dangerHelperText={errors["templateType"]}
            />
            <ShowHide
                evaluator={showRules}
                show={
                    <FormSelect
                        id="settings-template-rules"
                        headingText="Driving Hours Rules"
                        loading={loading}
                        disabled={saving || readOnly}
                        placeholder="Please select"
                        items={templateRules}
                        onItemSelect={onRulesSelect}
                        selectedValue={template.ruleset}
                        dangerHelperText={errors["ruleset"]}
                    />
                }
            />

        </>
    );
}